module.exports = __webpack_public_path__ + "static/media/img-background-l.e62c929c.jpg";